

























































































































































































































import { Component, Vue } from 'vue-property-decorator';
import DictSelect from '../../components/dict-select.vue';

@Component({
  name: 'VeicleListHeader',
  components: {
    DictSelect
  }
})
export default class remoteListHeader extends Vue {
  public query: object = {
    accidentStartDate: '',
    accidentEndDate: ''
  };
  public isUnfold: boolean = false;
  public loading: boolean = false;
  public pickerOptions: object = {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
  public accidentDate: object = {};
}
